import { DataSourceDetail, DataSourceListItem } from '@app/domain/entities';
import { PaginatedResponse } from '@app/shared/models/global.model';
import { DataSourceDetailDTO, DataSourceListItemDTO } from '../dtos';

export class DataSourcesMapper {
  dataSourceListItemToDomain(
    dto: PaginatedResponse<DataSourceListItemDTO>
  ): PaginatedResponse<DataSourceListItem> {
    return {
      data: dto.data.map(dtoItem => ({
        id: dtoItem.id,
        createdAt: dtoItem.createdAt,
        createdBy: dtoItem.createdBy,
        dataSourceCode: dtoItem.dataSourceCode,
        dataSourceDes: dtoItem.dataSourceDes,
        dataSourceName: dtoItem.dataSourceName,
        dataType: dtoItem.dataType,
        isActive: dtoItem.isActive,
        numOfValue: dtoItem.numOfValue,
        updatedAt: dtoItem.updatedAt,
        updatedBy: dtoItem.updatedBy,
        values: dtoItem.values,
        updatedByUsername: dtoItem.updatedByUsername,
      })),
      page: dto.page,
      size: dto.size,
      totalElements: dto.totalElements,
      totalPages: dto.totalPages,
    };
  }

  dataSourceDetailToDomain(dto: DataSourceDetailDTO): DataSourceDetail {
    return {
      id: dto.id,
      createdAt: dto.createdAt,
      createdBy: dto.createdBy,
      dataSourceCode: dto.dataSourceCode,
      dataSourceDes: dto.dataSourceDes,
      dataSourceName: dto.dataSourceName,
      dataType: dto.dataType,
      isActive: dto.isActive,
      numOfValue: dto.numOfValue,
      updatedAt: dto.updatedAt,
      updatedBy: dto.updatedBy,
      values: dto.values,
    };
  }
}
